import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-email-account-limits',
  templateUrl: './email-account-limits.component.html',
  styleUrls: ['./email-account-limits.component.scss'],
  standalone: false,
})
export class EmailAccountLimitsComponent {
  @Input() limitGroup: FormGroup<any>;
}
